export const deviceViewports = Object.freeze({
  desktopL: 1400,
  desktop: 1200,
  tabletL: 992,
  tablet: 768,
  mobileL: 576,
  mobile: 0,
});

export const deviceViewportArray = Object.entries(deviceViewports).reduce(
  (accum, curr) => {
    const [name, value] = curr;
    const newItem = { name, value };
    return accum.concat(newItem);
  },
  []
);

export const deviceViewportNames = Object.freeze({
  desktopL: 'desktopL',
  desktop: 'desktop',
  tabletL: 'tabletL',
  tablet: 'tablet',
  mobileL: 'mobileL',
  mobile: 'mobile',
});

export default deviceViewports;
